module.exports = __webpack_public_path__ + "assets/img/00007.4a5bf9c7.png";